export class CO2BetterServedReportFilters {
    siteIds: number[];
    canCrossBorders: boolean;
    trailerSize : number;
    distributionCost : number;
    constructor(siteIds, canCrossBorders, trailerSize, distributionCost) {
        this.siteIds = siteIds;
        this.canCrossBorders = canCrossBorders;
        this.trailerSize = trailerSize;
        this.distributionCost = distributionCost;
    }
}

export class ProposedPlants {
    lbu: string;
    siteID: number;
    siteCombined: string;
    isRealPlant: boolean;
}

export class CO2BetterServedReport {
    proposedPlant : string;
    prod : string;
    formerPlant : string;
    customer : string;
    sapCustomerID : number;
    savedMiles : number;
    tankCount : number;
    mTperDay : number;
    oldMiles : number;
    newMiles : number;
    saveddollar : number;
    customerCount : number;
}